/**
 * @ind-money/socket-manager Types
 *
 * Types are organized into separate files:
 * - common.ts   : Shared types (logger, analytics)
 * - websocket.ts: Base WebSocket types
 * - prices.ts   : Prices WebSocket types
 * - trades.ts   : Trades WebSocket types
 * - nats.ts     : NATS connection types
 * - provider.ts : Provider types
 * - hooks.ts    : Hook types
 *
 * @module types
 */

/**
 * Common Types
 */
export type {
  LogLevel,
  LoggerConfig,
  AnalyticsConfig,
  BaseSubscriptionInfo,
} from './common';

/**
 * WebSocket Types
 */
export type { WebSocketManagerConfig, ConnectionCallback } from './websocket';
export { WebSocketClientType } from './websocket';

/**
 * Prices Types
 */
export type {
  PricesWebSocketManagerConfig,
  PriceData,
  PriceCallback,
  PriceSubscriptionInfo,
} from './prices';

/**
 * Trades Types
 */
export type {
  TradesWebSocketManagerConfig,
  TradeData,
  TradesCallback,
  TradesSubscriptionInfo,
} from './trades';
export { TradeEventTypes, TradeEventMode } from './trades';

/**
 * NATS Types
 */
export type {
  NatsManagerConfig,
  NatsMessageCallback,
  NatsSubscriptionInfo,
  NatsConnectionStatus,
} from './nats';

/**
 * Provider Types
 */
export type {
  SocketManagerProviderConfig,
  SocketManagerContextValue,
} from './provider';

/**
 * Hook Types
 */
export type { LivePriceData, DataSource, MarketDepthData } from './hooks';
